import SvgIcon from './SvgIcon';

export default function CompanyIcon() {
  return (
    <SvgIcon width="100%" viewBox="0 0 22 22">
      <defs>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="company-linearGradient-1">
          <stop stopColor="#8E9DFF" offset="0%" />
          <stop stopColor="#B97BD3" offset="100%" />
        </linearGradient>
      </defs>
      <circle
        id="Oval-2"
        fill="url(#company-linearGradient-1)"
        opacity="0.340000004"
        cx="12"
        cy="12"
        r="12"
      />
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill={'url(#company-linearGradient-1)'}
        fillRule="evenodd">
        <g
          id="New-form-modal-Copy-13"
          transform="translate(-33.000000, -401.000000)"
          fill="#7393BE"
          fillRule="nonzero">
          <g id="Sidebar" transform="translate(22, 205) scale(0.5)">
            <path
              d="M43.5235924,403.133549 C43.8162221,402.955484 44.1842821,402.955484 44.4769118,403.133549 L54.6690882,409.331617 C54.8746178,409.456583 54.9999961,409.679122 55,409.918966 L55,410.762966 C54.9999878,410.884424 54.9515324,411.000902 54.8652945,411.086773 C54.7790566,411.172644 54.6621014,411.220873 54.5401609,411.220848 L53.1666934,411.220848 C52.9135666,411.220848 52.7083668,411.425236 52.7083668,411.677361 L52.7083668,419.977761 C52.7084077,420.136838 52.7915839,420.284423 52.9279052,420.367303 L54.6690882,421.426 C54.8746172,421.550945 54.9999981,421.773471 55,422.013304 L55,423.541935 C54.9999878,423.663434 54.9515193,423.779951 54.865257,423.865855 C54.7789946,423.951759 54.6620046,424.000012 54.5400234,424 L33.4584183,424 C33.2052915,424 33.0000917,423.795612 33.0000917,423.543488 L33.0000917,422.012345 C33.000103,421.773148 33.1251287,421.551206 33.3300869,421.426548 L35.0722323,420.36712 C35.2085131,420.284262 35.2916433,420.136701 35.2916332,419.977669 L35.2916332,411.677315 C35.2916332,411.42519 35.0864334,411.220803 34.8333066,411.220803 L33.4583266,411.220803 C33.2051998,411.220803 33,411.016415 33,410.76429 L33,409.917825 C33.0000144,409.678665 33.1250455,409.456765 33.3299952,409.332165 L43.5235924,403.133549 Z M47.6668653,419.888741 C47.6668653,420.140865 47.8720651,420.345253 48.1251919,420.345253 L49.9584985,420.345253 C50.2116253,420.345253 50.4168252,420.140865 50.4168252,419.888741 L50.4168252,411.677315 C50.4168252,411.42519 50.2116253,411.220803 49.9584985,411.220803 L48.1251919,411.220803 C47.8720651,411.220803 47.6668653,411.42519 47.6668653,411.677315 L47.6668653,419.888741 Z M42.6252721,419.888741 C42.6252721,420.140865 42.830472,420.345253 43.0835988,420.345253 L44.9169054,420.345253 C45.1700322,420.345253 45.375232,420.140865 45.375232,419.888741 L45.375232,411.677315 C45.375232,411.42519 45.1700322,411.220803 44.9169054,411.220803 L43.0835988,411.220803 C42.830472,411.220803 42.6252721,411.42519 42.6252721,411.677315 L42.6252721,419.888741 Z M44.0002521,408.935273 C44.7594136,408.935097 45.3747085,408.321999 45.3745904,407.565843 C45.3744722,406.809686 44.7589858,406.196779 43.9998243,406.196838 C43.2406628,406.196897 42.6252722,406.809899 42.6252721,407.566056 C42.6253987,408.322269 43.2409423,408.935212 44.0001604,408.935136 L44.0002521,408.935273 Z M37.583679,419.888741 C37.583679,420.140865 37.7888788,420.345253 38.0420056,420.345253 L39.8753122,420.345253 C40.1284391,420.345253 40.3336389,420.140865 40.3336389,419.888741 L40.3336389,411.677315 C40.3336389,411.42519 40.1284391,411.220803 39.8753122,411.220803 L38.0420056,411.220803 C37.7888788,411.220803 37.583679,411.42519 37.583679,411.677315 L37.583679,419.888741 Z"
              id="companies"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
